import logoImage from '../../../../images/white-logo.svg'
import React, { Component } from 'react'
import styled from 'styled-components'
import _ from 'lodash'

import { HEADER_BG_COLOR } from 'broker/util/constants'
import { isRootActiveTab } from 'broker/util/helper'

import IconMenu from 'broker/views/components/MobileNav/IconMenu'
import IconClose from 'broker/views/components/MobileNav/IconClose'
import MobileLink from 'broker/views/components/MobileNav/MobileLink'

const ClosedMenu = styled.nav`
  width: 100%;
  height: 48px;
  background-color: ${HEADER_BG_COLOR};
  display: flex;
  flex-direction: row;

  background-image: url(${logoImage});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 33%;
`

const OpenButtonWrapper = styled.div`
  padding: 16px 24px;
  cursor: pointer;
`

const OpenMenu = styled.nav`
  z-index: 999;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  padding: 21px 21px 40px;
  background-color: ${HEADER_BG_COLOR};
  min-height: 60px;
  display: flex;
  flex-direction: column;
`

const CloseButtonWrapper = styled.div`
  padding: 0;
  margin: 0 0 20px;
  cursor: pointer;
`

const TabsList = styled.div`
  padding-left: 4px;
`

const OpenNav = ({ handleClose, links }) => (
  <OpenMenu>
    <CloseButtonWrapper onClick={handleClose}>
      <IconClose/>
    </CloseButtonWrapper>
    <TabsList>
      {_.map(links, (l, idx) =>
        <MobileLink
          key={idx}
          value={l.value}
          label={l.label}
          active={isRootActiveTab(l.value)}
          handleClose={handleClose}
        />
      )}
    </TabsList>
  </OpenMenu>
)

class MobileNav extends Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false
    }

    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
  }

  handleOpen() {
    this.setState({
      open: true
    })
  }

  handleClose() {
    this.setState({
      open: false
    })
  }

  render() {
    return (
      <ClosedMenu>
        <OpenButtonWrapper onClick={this.handleOpen}>
          <IconMenu />
        </OpenButtonWrapper>
        {this.state.open && <OpenNav handleClose={this.handleClose} links={this.props.links} />}
      </ClosedMenu>
    )
  }
}

export default MobileNav
